import { render, staticRenderFns } from "./TMResultsReportTab.vue?vue&type=template&id=54339f36"
import script from "./TMResultsReportTab.vue?vue&type=script&lang=js"
export * from "./TMResultsReportTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports